export default __webpack_public_path__ + "ddaa83544710cef3e3c08d5b4530da6c.png";